<template>
  <div id="ContentRecharge" class="">
    <b-row>
      <b-col>
        <h2 class="pb-3">Recharge content</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs lazy>
          <b-tab title="Recharge" active>
            <Index />
          </b-tab>
          <b-tab title="Recharge WO">
            <Offer />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Index from '@/views/recharge/Index'
import Offer from '@/views/recharge/Offer'
export default {
  name: 'ContentRecharge',
  components: {
    Index,
    Offer
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/content/ContentRecharge.vue